'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 *
 * Init code provided by pendo. Slightly altered for integration with React.
 * https://support.pendo.io/hc/en-us/articles/360046272771-Developer-s-guide-to-installing-Pendo#the-install-script-snippet--0-4
 *
 */
function attachPendoWithZendesk(pendoApiKey, zendeskApiKey) {
    // eslint-disable-next-line func-names, @typescript-eslint/no-explicit-any
    return (function (p, e, n, d) {
        var v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
        // eslint-disable-next-line prettier/prettier, no-multi-assign, no-param-reassign
        var o = p[d] = p[d] || {};
        // eslint-disable-next-line no-underscore-dangle
        o._q = [];
        // eslint-disable-next-line func-names, no-underscore-dangle, prefer-rest-params, @typescript-eslint/explicit-function-return-type, prettier/prettier, no-plusplus
        for (var w = 0; w < v.length; ++w)
            (function (m) { o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); }; })(v[w]);
        var scriptEls = e.getElementsByTagName(n);
        var z = scriptEls.item(0);
        var zParent = z === null || z === void 0 ? void 0 : z.parentNode;
        var y = null;
        var zd = null;
        if (zParent) {
            y = e.createElement(n);
            y.id = 'pendo-init';
            y.async = true;
            y.src = "https://cdn.pendo.io/agent/static/" + pendoApiKey + "/pendo.js";
            zd = e.createElement(n);
            zd.id = 'ze-snippet';
            zd.async = true;
            zd.src = "https://static.zdassets.com/ekr/snippet.js?key=" + zendeskApiKey;
            zParent.insertBefore(y, z);
            y.after(zd);
        }
        return [y, zd];
    })(window, document, 'script', 'pendo');
}

exports.attachPendoWithZendesk = attachPendoWithZendesk;
